'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('groupAdmin', {
    url: '/admin/group/:id',
    template: require('./groupAdmin/groupAdmin.html'),
    controller: 'GroupAdminController',
    controllerAs: 'vm',
    authenticate: 'groupadmin'
  })
    .state('manager', {
      url: '/admin/manager',
      template: require('./manager/manager.html'),
      controller: 'ManagerController',
      controllerAs: 'vm',
      authenticate: 'safestartadmin'
    })
  .state('addQuestion', {
      url: "/question/add",
      template: require('./questions/questions.html'),
    controller: 'GroupAdminController',
    controllerAs: 'vm',
    authenticate: 'groupadmin'
    })
    .state('deleteQuestion', {
      url: "/question/add",
      template: require('./questions/questions.html'),
    controller: 'GroupAdminController',
    controllerAs: 'vm',
    authenticate: 'groupadmin'
    })
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.routes.js